import React from "react";
import { useTranslation } from "react-i18next";

// chips: [{ key, label, onRemove }]. "Limpiar filtros" quita nodos + fecha; el texto se
// conserva (contrato §3) — lo resuelve el padre pasando `clearFilters()` como onClearAll.
// `className` y `clearLabel` (OTT-2011): variante de la Agenda ("Limpiar" en vez de "Limpiar
// filtros"), sin cambiar los chips del buscador.
const FilterChips = ({ chips, onClearAll, className = "", clearLabel }) => {
  const { t } = useTranslation();
  if (!chips.length) return null;

  return (
    <div className={`bq-chips${className ? ` ${className}` : ""}`}>
      {chips.map((chip) => (
        <span className="bq-chip" key={chip.key}>
          <span>{chip.label}</span>
          <button type="button" aria-label={t("search.buscar.removeChip", { label: chip.label })} onClick={chip.onRemove}>
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
              <line x1="6" y1="6" x2="18" y2="18" />
              <line x1="18" y1="6" x2="6" y2="18" />
            </svg>
          </button>
        </span>
      ))}
      <button type="button" className="bq-clear-filters" onClick={onClearAll}>
        {clearLabel || t("search.buscar.clearFilters")}
      </button>
    </div>
  );
};

export default FilterChips;
